module.exports = __webpack_public_path__ + "img/logo-webmag-big.84eafa0a.png";